import React from 'react'
import s from './student-analytics.module.scss'
import classNames from 'classnames';
import { useAnalytics } from '@shared/api/useAnalytics';
import { Button } from '@shared/ui/button/button';

export const StudentAnalytics = ({className, compact}) => {
	const lineWidth = (number, max) => {
		return (number / max)*100
	}

	const {data: analytics} = useAnalytics()

	return (
		<div className={classNames(className, s.card)}>
			<div className={s.title}>
				Личный рейтинг
			</div>
			<ul className={s.ratingLines}>
				<li>
				<div className={s.ratingTitle}>Пройденых занятий:</div>

					<div className={s.ratingWrapper}>
						<div className={s.ratingLineNumber}>{analytics?.appointments_count}/100</div>
						<div className={s.ratingLine}>
							<span style={{width: lineWidth(analytics?.appointments_count, 100) + '%'}}></span>
						</div>
					</div>
				</li>
				<li>
					<div className={s.ratingTitle}>Часов за учебой:</div>
					<div className={s.ratingWrapper}>
						<div className={s.ratingLineNumber}>{Math.round(analytics?.appointment_hours * 10) / 10}/100</div>
						<div className={s.ratingLine}>
							<span style={{width: lineWidth(analytics?.appointment_hours, 100) + '%'}}></span>
						</div>
					</div>
				</li>
			</ul>
			<Button size={compact || 'small'} label={'Записаться'} className={classNames(s.btn, compact ? s.compact : '')} to="/teachers"/>
			<img src={"./images/fire-dynamic-color.png"} alt="" className={s.img}/>
		</div>
	)
}
